import { render, staticRenderFns } from "./batch-products-container.vue?vue&type=template&id=111ad248&scoped=true&lang=pug"
import script from "./batch-products-container.js?vue&type=script&lang=js&external"
export * from "./batch-products-container.js?vue&type=script&lang=js&external"
import style0 from "./batch-products-container.vue?vue&type=style&index=0&id=111ad248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ad248",
  null
  
)

export default component.exports